import { css, Theme } from "@emotion/react";
import { media } from "styles/breakpoints";

export const PromotionCategoryStyle = {
  self: ({ colors, fontSize }: Theme) => css`
    & .ant-radio {
      &-group {
        display: flex;
        gap: 10px;
        flex-wrap: wrap;
        width: 100%;
        ${media.sm} {
          gap: 10px;
        }
      }
      &-button-wrapper {
        height: 42px;
        color: ${colors.white};
        background: url(https://0kqo9br0eyii.jquut.net/system-requirement/Web.PortalNew/UK254-01/69713be0e6/images/92ccbd8913518140bb13c55fe11a20a0.png)
          center top;
        font-size: ${fontSize[16]};
        padding: 0 5px;
        border: none;
        min-width: 120px;
        text-align: center;
        border-radius: 0;
        line-height: 42px;
        transition: none;

        ${media.sm} {
          min-width: unset;
          background: rgb(123 191 212) !important;
          opacity: 0.5;
          font-size: 12px;
          height: 24px;
          display: flex;
          align-items: center;
          justify-content: center;
          line-height: unset;
          border-radius: 4px;
          padding: 0 10px;
          &:has(.ant-radio-button-checked) {
            opacity: 1;
          }
        }
        &::before {
          display: none;
        }
        & .ant-radio-button-checked {
          background-color: unset !important;
          border-radius: 4px;

          ${media.sm} {
            background: rgb(123 191 212) !important;
            opacity: 1;
          }
        }

        &-checked,
        &:hover {
          background: url(https://0kqo9br0eyii.jquut.net/system-requirement/Web.PortalNew/UK254-01/69713be0e6/images/92ccbd8913518140bb13c55fe11a20a0.png)
            center top !important;
          border: none !important;
          background-position: bottom !important;
        }
      }
    }
  `,
};
